import { EJRecordTypes } from 'src/common/enumerations/ej-record-types';
import { IElectronicJournalRecord } from 'src/common/interfaces/states/IElectronicJournalRecord';
import { store } from 'src/common/redux/configure-store';

//TODO: We need revert this code when SE fixed the problem check here https://jira.ncr.com/browse/XLR-6744

export const validateVoidItemEftTender = (): boolean => {
  const products = store.getState().itemList.ejItems.filter(i => i.Type === EJRecordTypes.Product);

  if (products.length === 1) {
    const tender = store
      .getState()
      .itemList.ejItems.find(
        (item: IElectronicJournalRecord) =>
          item.Type === EJRecordTypes.Tender && item.IsProcessedByEps && !item.Voided,
      );

    if (tender) {
      return true;
    }
  }

  return false;
};
